import './view-nav-selected.css';
import { h } from 'preact';

export default function ViewNavSelected({ name, shapes, backgroundImageThumb }) {
	return (
		<div class="view-nav-selected">
			<div class="view-nav-selected-view-thumbnail-wrapper">
				<div class="view-nav-selected-view-thumbnail-container">
					<img src={backgroundImageThumb.src} />
				</div>
				<span class="view-nav-selected-view-view-thumbnail-container-plot-number-count">{shapes.length}</span>
			</div>
			<div class="view-nav-selected-name">
				{name}
			</div>
		</div>
	);
}
